import React, { PropsWithChildren, ReactNode } from 'react';
import { ButtonProps } from '../../../../types/HtmlProps';

export type ContextMenuButtonProps = PropsWithChildren<ButtonProps>;

export function ContextMenuButton(props: ContextMenuButtonProps): ReactNode {
  return <button {...props} type="button" className="context-menu__button font-regular-15-21" />;
}
